import createKmlWorker from './createKmlWorker';

export function parseKmlInWorker(buffer, { signal, timeoutMs = 15000 } = {}) {
    return new Promise((resolve, reject) => {
        let worker;
        let timer;
        let finished = false;
        const finish = (callback, value) => {
            if (finished) return;
            finished = true;
            clearTimeout(timer);
            signal?.removeEventListener('abort', abort);
            worker?.terminate();
            callback(value);
        };
        const abort = () => finish(reject, Object.assign(new Error('已取消 KML 載入。'), { name: 'AbortError' }));
        if (signal?.aborted) { abort(); return; }
        try {
            worker = createKmlWorker();
            signal?.addEventListener('abort', abort, { once: true });
            timer = setTimeout(() => finish(reject, new Error('KML 解析逾時，已停止解析。')), timeoutMs);
            worker.onmessage = ({ data }) => data.error ? finish(reject, new Error(data.error)) : finish(resolve, data.result);
            worker.onerror = event => { event.preventDefault(); finish(reject, new Error('KML 解析失敗，請檢查檔案。')); };
            worker.postMessage(buffer, [buffer]);
        } catch (error) { finish(reject, error); }
    });
}
